import { produce } from 'immer';

import {
    Action,
    ExtensionContainerElementIdChange,
    ExtensionHtmlContentUpdate,
    ExtensionHtmlPendingLoadCheck,
    ExtensionOutOfNetwork,
    ExtensionPageUrlChange,
    ExtensionProfileParsed,
    ExtensionProfileParsingStatusChange,
    ExtensionRawJsonUpdate,
    ExtensionScrollToPendingTags,
    ExtensionUpdateSelectedJob,
    ReceiveCandidateAddedToJob
} from '../actions';
import { getLocalStorageKey, selectedJobIdKey } from '../common/local-storage';
import { ExtensionState } from '../state';

const initialState: ExtensionState = {
    // Messaging & UI state
    autoExpandingPendingSections: false,
    autoScrollToPendingHtmlTags: false,
    containerElementId: null,
    firstLoadTime: Date.now(),
    htmlPendingLoadTagsCount: null,
    htmlProfile: null,
    jsonProfile: null,
    outOfNetwork: false,
    parsingError: null,
    parsingProfile: null,
    selectedJobId: getLocalStorageKey(selectedJobIdKey, null),
    url: null,

    // Parsed result from parseProfile
    blacklistCheck: null,
    nextSendTime: null,
    person: null,
    personId: null,
    profile: null
};

export function extension(state = initialState, action: Action): ExtensionState {
    return produce(state, (draft) => {
        switch (action.type) {
            case ExtensionOutOfNetwork:
                draft.outOfNetwork = true;
                break;
            case ExtensionRawJsonUpdate:
                draft.jsonProfile = action.payload.jsonProfile;
                draft.url = action.payload.url;
                break;
            case ExtensionUpdateSelectedJob:
                draft.selectedJobId = action.payload.jobId;
                break;
            case ExtensionHtmlPendingLoadCheck:
                draft.url = action.payload.url;
                break;
            case ExtensionProfileParsingStatusChange:
                draft.parsingProfile = action.payload.parsingProfile;
                break;
            case ExtensionProfileParsed:
                if (action.payload.extension && !action.payload.extension.parsingError) {
                    // Store minimal parsed data from server response
                    Object.assign(draft, action.payload.extension);
                } else {
                    draft.parsingError = action.payload?.extension?.parsingError ?? 'Profile parsing error';
                }
                break;
            case ReceiveCandidateAddedToJob:
                // Update blacklist check to reflect candidate was added
                draft.blacklistCheck = produce(draft.blacklistCheck, (b) => {
                    b.alreadyInJob = true;
                });
                // Note: candidates list is now managed by GraphQL queries
                // Components will refetch after this action
                break;
            case ExtensionHtmlContentUpdate:
                draft.htmlPendingLoadTagsCount = action.payload.pendingCount;
                draft.htmlProfile = action.payload.html;
                break;
            case ExtensionPageUrlChange:
                Object.assign(draft, initialState, {
                    firstLoadTime: Date.now(),
                    selectedJobId: draft.selectedJobId
                });
                break;
            case ExtensionContainerElementIdChange:
                draft.containerElementId = action.payload.containerElementId;
                break;
            case ExtensionScrollToPendingTags:
                draft.autoScrollToPendingHtmlTags = action.payload.useAutoScroll;
                draft.autoExpandingPendingSections = action.payload.autoExpand;
                break;
            // ExtensionReceiveJobs removed - jobs now fetched via GraphQL
            default:
                break;
        }
    });
}
